import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../../components/layout";
import UserCreateForm from "../../../components/users/UserCreateForm";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  fetchRoleData,
  fetchPermissionData,
  fetchBranchesData,
} from "../../../features/users/usersSlice";
import { getLoggingUser } from "../../../features/loggingUser/loggingUserSlice";
import { getSelectedBranch } from "../../../features/settings/settingsSlice";
import { useCanAccess } from "../../../hooks/useCanAccess";
import { t } from "../../../locales";
import { route } from "../../../static/route";

const UsersCreatePage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const canAccess = useCanAccess();
  const loggingUser = useAppSelector(getLoggingUser);
  const selectedBranch = useAppSelector(getSelectedBranch);

  useEffect(() => {
    if (loggingUser?.permissions && selectedBranch) {
      if (!canAccess("users.create")) {
        navigate(route.dashboard);
        return;
      }
      dispatch(fetchRoleData());
      dispatch(fetchPermissionData());
      dispatch(fetchBranchesData());
    }
  }, [loggingUser, selectedBranch]);

  return (
    <Layout>
      <div className="px-2 py-4 md:px-6 md:py-6">
        {/* Breadcrumb */}
        <nav className="text-sm font-semibold text-gray-500 mb-4">
          <Link
            to={route.dashboard}
            className="text-brand-dark hover:underline"
          >
            {t.users.breadcrumbHome}
          </Link>
          <span className="mx-2">&rsaquo;</span>
          <Link to={route.users} className="text-brand-dark hover:underline">
            {t.users.breadcrumbUsers}
          </Link>
          <span className="mx-2">&rsaquo;</span>
          <span className="text-gray-500">{t.users.breadcrumbCreate}</span>
        </nav>

        {/* Page title */}
        <h1 className="text-2xl font-bold text-brand-dark mb-6">
          {t.users.breadcrumbCreate}
        </h1>

        <UserCreateForm />
      </div>
    </Layout>
  );
};

export default UsersCreatePage;
